import React from 'react'

const Manual_conexion_de_cuenta = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     MarketMan - Conexión de Cuenta
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía proporciona un proceso sencillo para integrar su cuenta con MarketMan,
          garantizando una sincronización de datos fluida. Siguiendo estos pasos, podrá
          configurar fácilmente su cuenta y enviar transacciones manualmente si es
          necesario, mejorando así su eficiencia operativa.
     </p>
     <iframe
          src="https://scribehow.com/embed/MarketMan__Conexion_de_Cuenta__pA8e5IwnTLGPLgqTY3iiQg?as=scrollable"
          className="scribe-iframe-marketman-1"
          width="100%"
          height="3450"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_conexion_de_cuenta